import { createClient } from './supabase/client';

export interface AuditEntry {
  action: string;
  module: string;
  details?: Record<string, any>;
}

export async function logAuditEvent(entry: AuditEntry): Promise<void> {
  try {
    const supabase = createClient();
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) return;

    const { data: profile } = await supabase
      .from('staff_profiles')
      .select('id, full_name, role')
      .eq('user_id', user.id)
      .single();

    await supabase.from('audit_logs').insert({
      staff_id: profile?.id ?? null,
      staff_name: profile?.full_name ?? user.email ?? 'Unknown',
      staff_role: profile?.role ?? 'unknown',
      action: entry.action,
      module: entry.module,
      details: entry.details ?? {},
    });
  } catch {
    // Audit logging should never break the app
  }
}
